import { Header } from './navigation/Header';

const TopRibbon = () => <Header />;

export default TopRibbon;
